import { PublicClientApplication } from "@azure/msal-browser"
import { useMainStore } from "@/store"

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}`,
    redirectUri: process.env.VUE_APP_REDIRECT_URI || window.location.origin
  },
  cache: {
    cacheLocation: "localStorage"
  }
}

const loginRequest = {
  scopes: [`api://${process.env.VUE_APP_CLIENT_ID}/access_as_user`]
}

export const msalInstance = new PublicClientApplication(msalConfig)

export async function initializeAuth() {

  await msalInstance.initialize()

  const response = await msalInstance.handleRedirectPromise()

  if (response) {
    msalInstance.setActiveAccount(response.account)
  }

  let account = msalInstance.getActiveAccount()

  if (!account) {
    const accounts = msalInstance.getAllAccounts()

    if (accounts.length > 0) {
      account = accounts[0]
      msalInstance.setActiveAccount(account)
    }
  }

  if (!account) {
    await msalInstance.loginRedirect(loginRequest)
    return
  }

  const store = useMainStore()

  try {

    const tokenResponse = await msalInstance.acquireTokenSilent({
      account,
      scopes: [`api://${process.env.VUE_APP_CLIENT_ID}/access_as_user`]
    })

    console.log("tokenResponse", tokenResponse)

    // check expiry
    const expiresOn = new Date(tokenResponse.expiresOn)
    const now = new Date()

    if (expiresOn <= now) {
      console.log("Token expired. Redirecting to login...")
      await msalInstance.loginRedirect(loginRequest)
      return
    }

    // save to store
    store.token = tokenResponse.accessToken
    store.tokenType = tokenResponse.tokenType
    store.expiresOn = tokenResponse.expiresOn
    store.userId = tokenResponse.account.username
    store.name = tokenResponse.account.name
    store.authenticated = true
    console.log("Token valid until:", expiresOn)

  } catch (error) {

    console.log("Silent token failed, redirecting to login", error)

    await msalInstance.loginRedirect(loginRequest)
  }

  return account
}